var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('LoginCard',{attrs:{"isLoading":_vm.isLoading},on:{"login":_vm.onLogin,"gotoSignup":_vm.handleGotoSignup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }